import BrowseSearchPage from './BrowseSearchPage.container';

export default BrowseSearchPage;
